import tooltipDirective from "./Tooltip/"
import animatedDetails from "./animatedDetails"

// register all directives
const directives = (app) => {
    tooltipDirective(app)
    app.directive("animated-details", animatedDetails)
}

export default directives
